import {
  Color,
  Vector3,
  Object3D,
  MathUtils,
  LineBasicMaterial,
  CatmullRomCurve3,
  AdditiveBlending,
  SpriteMaterial,
  BufferGeometry,
  Points,
  PointsMaterial,
  Float32BufferAttribute,
} from 'three';

const SPRITED = Symbol('sprited');

export const sprinkleSprites = function(
  source,
  texture,
  {
    scale = 1,
    count = 1,
    genOffset = 0,
    slide = 0,
    transparent = false,
    opacity = 1,
    offset,
  },
) { 
  const sprite = new Object3D();
  const vertices = [];
  for (const line of source.children) {
    if (!line.isLine) continue;

    const geo = line.geometry.attributes.position;
    const pts = [];
    for (let i = 0; i < geo.count; i++) {
      pts.push(new Vector3().fromBufferAttribute(geo, i));
    }

    const curve = new CatmullRomCurve3(pts, false);
    for (let i = 0; i < count; i++) {
      const off = MathUtils.randFloat(0, slide);
      const placement = (i / count + off) % 1;
      const item = curve.getPointAt(placement);
      sprite.position.set(
        item.x + MathUtils.randFloat(-genOffset, genOffset),
        item.y + MathUtils.randFloat(-genOffset, genOffset),
        item.z + MathUtils.randFloat(-genOffset, genOffset),
      );
      const wPos = sprite.localToWorld(sprite.position);
      wPos.x -= offset?.x ?? 0;
      wPos.y -= offset?.y ?? 0;
      wPos.z -= offset?.z ?? 0;
      const lPos = sprite.worldToLocal(wPos);
      sprite.position.set(lPos.x, lPos.y, lPos.z);

      sprite.applyMatrix4(line.matrix);

      vertices.push(
        sprite.position.x,
        sprite.position.y,
        sprite.position.z,
      );
    }
  }

  const material = new PointsMaterial({
    size: scale,
    map: texture,
    blending: AdditiveBlending,
    fog: false,
    depthTest: false,
    toneMapped: false,
    transparent,
    opacity,
  });
  const geometry = new BufferGeometry();
  geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
  const points = new Points(geometry, material);
  source.add(points);
};

export const spriteSpiral = (spiral, texture, configs) => {
  if (spiral[SPRITED]) return;
  spiral[SPRITED] = true;

  for (let i = 0; i < configs.length; i++) {
    const config = configs[i];
    const { children = spiral.children } = config;
    sprinkleSprites(children[i], texture, config);
  }
};

export default function formatSpiral(spiral, {
  lineOpacity = 0.5,
  spriteOpacity = 1,
} = {}) {
  const lineMat = new LineBasicMaterial({
    color: new Color(1.5, 1.2, 0.8),
    linewidth: 2,
    opacity: lineOpacity,
    blending: AdditiveBlending,
    transparent: true,
  });

  const spriteMat = new SpriteMaterial({
    blending: AdditiveBlending,
    color: new Color(2, 1.8, 1.6),
    fog: false,
    opacity: spriteOpacity,
    sizeAttenuation: true,
    transparent: true,
    depthTest: false,
  });

  spiral.lineMat = lineMat;
  spiral.spriteMat = spriteMat;

  spiral.traverse(function(child) {
    if (child.isLine) child.material = lineMat;
  });

  return spiral;
};